package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.RedditSimpleIcons: ImageVector
    get() {
        if (_redditSimpleIcons != null) {
            return _redditSimpleIcons!!
        }
        _redditSimpleIcons = Builder(name = "RedditSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(12.0f, 0.0f)
                curveTo(5.37f, 0.0f, 0.0f, 5.37f, 0.0f, 12.0f)
                curveToRelative(0.0f, 3.31f, 1.34f, 6.31f, 3.52f, 8.49f)
                lineToRelative(-2.29f, 2.29f)
                curveTo(0.78f, 23.23f, 1.10f, 24.0f, 1.74f, 24.0f)
                lineTo(12.0f, 24.0f)
                curveToRelative(6.63f, 0.0f, 12.0f, -5.37f, 12.0f, -12.0f)
                reflectiveCurveTo(18.63f, 0.0f, 12.0f, 0.0f)
                close()
                moveTo(16.39f, 3.20f)
                curveToRelative(1.10f, 0.0f, 2.00f, 0.90f, 2.00f, 2.00f)
                curveToRelative(0.0f, 1.11f, -0.90f, 2.0f, -2.00f, 2.0f)
                curveToRelative(-0.95f, 0.0f, -1.74f, -0.66f, -1.95f, -1.54f)
                verticalLineToRelative(0.00f)
                curveToRelative(-1.15f, 0.16f, -2.03f, 1.15f, -2.03f, 2.34f)
                verticalLineToRelative(0.01f)
                curveToRelative(1.78f, 0.07f, 3.4f, 0.57f, 4.69f, 1.36f)
                curveToRelative(0.47f, -0.36f, 1.06f, -0.58f, 1.71f, -0.58f)
                curveToRelative(1.55f, 0.0f, 2.80f, 1.25f, 2.80f, 2.80f)
                curveToRelative(0.0f, 1.12f, -0.66f, 2.08f, -1.60f, 2.53f)
                curveToRelative(-0.09f, 3.26f, -3.64f, 5.88f, -8.00f, 5.88f)
                curveToRelative(-4.36f, 0.0f, -7.91f, -2.62f, -8.00f, -5.87f)
                curveToRelative(-0.95f, -0.45f, -1.61f, -1.42f, -1.61f, -2.54f)
                curveToRelative(0.0f, -1.55f, 1.26f, -2.80f, 2.80f, -2.80f)
                curveToRelative(0.65f, 0.0f, 1.24f, 0.22f, 1.71f, 0.59f)
                curveToRelative(1.28f, -0.79f, 2.88f, -1.29f, 4.64f, -1.37f)
                verticalLineToRelative(-0.01f)
                curveToRelative(0.0f, -1.66f, 1.26f, -3.03f, 2.88f, -3.21f)
                curveToRelative(0.19f, -0.91f, 0.99f, -1.60f, 1.96f, -1.60f)
                close()
                moveTo(8.30f, 11.58f)
                curveToRelative(-0.78f, 0.0f, -1.46f, 0.78f, -1.51f, 1.80f)
                curveToRelative(-0.05f, 1.02f, 0.64f, 1.43f, 1.43f, 1.43f)
                curveToRelative(0.79f, 0.0f, 1.37f, -0.37f, 1.42f, -1.39f)
                curveToRelative(0.05f, -1.02f, -0.55f, -1.84f, -1.34f, -1.84f)
                close()
                moveTo(15.71f, 11.58f)
                curveToRelative(-0.79f, 0.0f, -1.39f, 0.82f, -1.34f, 1.84f)
                curveToRelative(0.05f, 1.02f, 0.63f, 1.39f, 1.42f, 1.39f)
                curveToRelative(0.79f, 0.0f, 1.47f, -0.41f, 1.43f, -1.43f)
                curveToRelative(-0.05f, -1.02f, -0.72f, -1.80f, -1.51f, -1.80f)
                close()
                moveTo(12.01f, 15.59f)
                curveToRelative(-0.97f, 0.0f, -1.91f, 0.05f, -2.77f, 0.14f)
                curveToRelative(-0.15f, 0.02f, -0.24f, 0.17f, -0.18f, 0.31f)
                curveToRelative(0.48f, 1.15f, 1.62f, 1.96f, 2.95f, 1.96f)
                curveToRelative(1.33f, 0.0f, 2.47f, -0.81f, 2.95f, -1.96f)
                curveToRelative(0.06f, -0.14f, -0.04f, -0.29f, -0.18f, -0.31f)
                curveToRelative(-0.86f, -0.09f, -1.80f, -0.14f, -2.77f, -0.14f)
                close()
            }
        }
        .build()
        return _redditSimpleIcons!!
    }

private var _redditSimpleIcons: ImageVector? = null
